import getWrappedUseQuery from "api/helpers/getWrappedUseQuery";
import apiClient from "api-client";

import KEYS from "../keys";

export const useGetFileImportQuery = getWrappedUseQuery(KEYS.GET_FILE_IMPORT, apiClient.FileImport.get);
